import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Link from '../../../../Core/Link';

// Please note: this stylesheet contains styles for the horizontal and stacked design in media queries
// to use the stacked version just move these styles out of the blocks they are in and comment them out

// export const Modal = styled(Modal)`
//   height: fit-content;

//   @media only screen and (min-height: 750px) {
//     height: fit-content;
//   }
// `;

export const Image = styled.img`
  height: auto;
  max-height: 90%;
  max-width: 239px;
  padding-top: 10px;
  width: 70%;
`;

// Start of Styled Components
// move media query into block and remove comment for horizontal design
// xs screens footer below the fold
export const ProdigyAgeGateMain = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  margin: auto;
  width: fit-content;
  padding: 20px 0;

  h3,
  h4,
  h5,
  h6 {
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
  }
`;
// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.md'
// )} + 1px)) {
//   flex-direction: row;
// }

// move media query into block and remove comment for horizontal design
export const ProdigyWebsite = styled.div`
  align-items: center;
  background-color: ${({ sectionTwoBGColourOverride }) =>
    sectionTwoBGColourOverride || themeGet('colors.white')};
  border-radius: 0 0 10px 10px;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  padding: 20px;
  outline: none;
  border: none;

	img {
    max-width: 140px;
    width: 40%;
  }

	@media only screen and (min-width: calc(${themeGet(
      'breakpoints.lg'
    )} + 1px)) {
    width: 500px;
  }

	@media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 530px;
  }
`;
// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.md'
// )} + 1px)) {
//   border-radius: 0px 10px 10px 0px;
//   flex: 1;
//   margin: 0px;
//   padding: 90px 20px 40px 20px;

//   .image-continue{
//     margin: 24px 0px
//     max-width: 227px;
//   }
// }

export const ProdigyWebsiteButton = styled.button`
  background-color: ${themeGet('colors.white')};
  border-radius: 4px;
  border: 2px solid ${themeGet('colors.orange')};
  color: ${themeGet('colors.black')};
  font-size: 18px;
  font-weight: 600;
  margin: 5px 0 0;
  min-width: 260px;
  padding: 11px 22px;
  text-align: center;
  text-decoration: none;
  transition: all 500ms ease;

  &:hover,
  &:focus {
    background-color: ${themeGet('colors.orange')};
    border-color: ${themeGet('colors.orange')};
    color: ${themeGet('colors.white')};
  }

	&:focus,
  &:active {
    background-color: ${themeGet('colors.dorange')};
    border-color: ${themeGet('colors.orange')};
    color: ${themeGet('colors.white')};
  }

	@media only screen and (min-width: calc(${themeGet(
      'breakpoints.lg'
    )} + 1px)) {
    margin-top: 10px;
  }
`;

// move media queries into block and remove comment for horizontal design
export const ProdigyGamePlay = styled.div`
  align-items: center;
  background-color: ${({ sectionOneBGColourOverride }) =>
    sectionOneBGColourOverride || themeGet('colors.cream')};
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  padding: 20px 20px 30px;
  outline: none;
  border: none;

	.btn {
    border-width: 2px;
    font-size: 18px;
    margin: 5px 0 0;
    min-width: 260px;

		@media only screen and (min-width: calc(${themeGet(
        'breakpoints.lg'
      )} + 1px)) {
      margin-top: 10px;
    }
  }
`;

export const ProdigyGamePlayLink = styled(props => <Link {...props} />)``;

// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.lg'
// )} + 1px)) {
//   max-width: 500px;
// }

// @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
//   width: 530px;
// }

// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.md'
// )} + 1px)) {
//   border-radius: 10px 0px 0px 10px;
//   flex: 1;
//   margin: 0;
//   padding: 90px 20px 40px 20px;

//   .image-game{
//     max-width: 380px;
//   }
// }
// add this for stacked design

// move media query into block and remove comment for horizontal design
export const ProdigyLogoMain = styled.div`
  background: ${themeGet('colors.cream')};
  border-radius: 10px 10px 0 0;
  margin: 10px 10px -1px 10px;
  order: -1;
  position: relative;
  text-align: center;
  z-index: 1;
`;

// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.md'
// )} + 1px)) {
//   left: 0;
//   margin-left: auto;
//   margin-right: auto;
//   margin-top: 0px;
//   order: 1;
//   position: absolute;
//   right: 0;
//   text-align: center;
//   width: 200px;
// }

// move media query into block and remove comment for horizontal design
export const ProdigyLogo = styled.img`
  background-color: ${themeGet('colors.orange')};
  height: auto;
  margin: -1px 0;
  padding: 10px 40px;
  width: 200px;
`;
// @media only screen and (min-width: calc(${themeGet(
//   'breakpoints.md'
// )} + 1px)) {
//   border-radius: 0px;
//   padding: 10px 40px;
//   width: 100%;
// }

// xs screens footer below the fold
export const CookieConsentBanner = styled.div`
  background-color: ${themeGet('colors.maroon')};
  bottom: 0;
  display: block;
  left: 0;
  margin: 10px 0 0;
  padding: 20px 17px;
  width: 100%;

  @media only screen and (min-height: 800px){
    position: absolute;
  }
`;

export const CookieConsentText = styled.div`
  margin: auto;

	> p {
    color: ${themeGet('colors.white')};
    font-size: 12px;
    line-height: 20px;
    text-align: center;

		> a {
      color: ${themeGet('colors.white')};
      font-weight: 600;
      text-decoration: underline;
    }

		@media only screen and (min-width: calc(${themeGet(
        'breakpoints.md'
      )} + 1px)) {
      margin: 0 auto;
      max-width: 72%;
    }
  }
`;
